.icon {
  color: var(--color-text-secondary);
}

.added {
  font: var(--font-label-2);
}
